import type { ReactNode } from 'react'

import { esDeAgencia, LogoDeMarca, marca, nombreDeLaMarca } from '../marca/marca'

/**
 * El armazón de las pantallas de fuera: entrar, recuperar la contraseña y ponerla. La marca
 * arriba, el formulario en medio y, en escritorio, el degradado de marca a la derecha: el
 * único sitio del panel donde los dos acentos conviven.
 */
export const PantallaDeAcceso = ({ children }: { children: ReactNode }) => (
  <div className="grid min-h-full lg:grid-cols-[1fr_1.1fr]">
    <div className="flex flex-col p-6 sm:p-10">
      <LogoDeMarca tamano="grande" />
      <div className="my-auto w-full max-w-sm self-center py-12">{children}</div>
      <p className="text-xs text-tenue">© {nombreDeLaMarca()}</p>
    </div>

    <div className="relative hidden overflow-hidden lg:block" style={{ background: 'var(--gradiente-marca)' }}>
      <div className="absolute inset-x-12 bottom-12 text-white/90">
        {esDeAgencia() ? (
          <p className="font-display text-3xl font-semibold tracking-tight">{marca()?.lema ?? marca()?.nombre}</p>
        ) : (
          <>
            <p className="font-display text-3xl font-semibold tracking-tight">Tu web es código de verdad.</p>
            <p className="mt-3 max-w-md text-[15px] text-white/70">Lo que escribes lo guardas tú; cómo se ve lo decide un diseño que puedes revisar, comparar y revertir.</p>
          </>
        )}
      </div>
    </div>
  </div>
)
